import * as React from 'react'

import * as styles from './cardArea.module.css'

interface IProps {
  children?: React.ReactNode
}

const CardArea: React.SFC<IProps> = ({ children }) => {
  return <li className={styles.root}>{children}</li>
}

export default CardArea
